export type Person = {
  firstName?: string;
  lastName?: string;
  secondName?: string;
};

type NameFormat = 'formal' | 'display';

export const getPersonFullName = (person: Person, format: NameFormat = 'formal'): string => {
  const { firstName, lastName, secondName } = person;

  let order = [lastName, firstName, secondName];
  if (format === 'display') {
    order = [firstName, lastName];
  }
  return firstName || lastName || secondName
    ? order
        .filter((item) => Boolean(item))
        .join(' ')
        .trim()
    : '';
};

export const getUppercaseName = (person: Person, format: NameFormat = 'formal') =>
  getPersonFullName(person, format).toUpperCase();
